import { render } from "./MobPrivacy.vue?vue&type=template&id=d50d5842&scoped=true"
import script from "./MobPrivacy.vue?vue&type=script&lang=js"
export * from "./MobPrivacy.vue?vue&type=script&lang=js"

import "./MobPrivacy.vue?vue&type=style&index=0&id=d50d5842&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d50d5842"]])

export default __exports__